import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import { omitBy, isUndefined } from 'lodash';
export function isHeadingItem(item) {
  return item === null || item === void 0 ? void 0 : item.isHeading;
}
export function createFakeEvent(value) {
  return {
    target: {
      value: value
    }
  };
}
export function removeUndefined(obj) {
  return omitBy(obj, isUndefined);
}
export function showFreeform(_ref) {
  var _context, _context2;

  var freeform = _ref.freeform,
      inputValue = _ref.inputValue,
      items = _ref.items,
      selectedItems = _ref.selectedItems,
      selectedItem = _ref.selectedItem,
      itemToString = _ref.itemToString;
  return freeform && inputValue.length > 0 && !_findInstanceProperty(_context = _concatInstanceProperty(_context2 = []).call(_context2, _toConsumableArray(items), _toConsumableArray(selectedItems), [selectedItem])).call(_context, function (item) {
    if (!isHeadingItem(item)) {
      return itemToString(item) === inputValue;
    }

    return false;
  });
}